document.querySelectorAll('.section--textmedia-expand').forEach(item => {
    const button = item.querySelector('button')
    const container = item.querySelector('.container')
    const lang = document.documentElement.lang
    
    button.addEventListener('click', () => {
        item.classList.toggle('active')

        if (item.classList.contains('active')) {
            button.setAttribute('aria-expanded', 'true')
            container.removeAttribute('hidden')

            if (lang == 'de') {
                button.querySelector('div.label').textContent = 'Weniger anzeigen'
            }
            if (lang == 'en') {
                button.querySelector('div.label').textContent = 'Show less'
            }
        }

        else {
            button.setAttribute('aria-expanded', 'false')
            container.setAttribute('hidden', '')
            
            if (lang == 'de') {
                button.querySelector('div.label').textContent = 'Mehr anzeigen'
            }
            if (lang == 'en') {
                button.querySelector('div.label').textContent = 'Show more'
            }
        }
    })
})